module.exports = __webpack_public_path__ + "static/img/4.55bf8c8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/5/1/zh/4.png
// module id = q0jA
// module chunks = 0